/**
 * 商品カテゴリー一覧画面の初期化
 */
export function initSampleSeriesWeboothCategory() {
    initSubmitButton();
}
/**
 * 中/小カテゴリー名ボタンの初期化
 */
function initSubmitButton() {
    const form = document.getElementById("sample-series-webooth-category-form");
    if (form === null)
        return;
    const elements = document.getElementsByClassName("btn-webooth-category-menu");
    for (const element of elements) {
        const button = element;
        button.addEventListener("click", () => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "base-category-id";
            input.value = button.dataset.id;
            form.appendChild(input);
            form.submit();
            form.removeChild(input);
        });
    }
}
